import { render, staticRenderFns } from "./InfoTemp.vue?vue&type=template&id=6a8baaa3"
import script from "./InfoTemp.vue?vue&type=script&lang=js"
export * from "./InfoTemp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports